import React, {useEffect, useState} from 'react';
import CountUp from "react-countup";
import { useInView } from 'react-intersection-observer';
import axios from 'axios';

const StudentsCounter = () => {

    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.3
    });

    const[counter,setCounter]= useState([]);
    useEffect(()=>{
        axios.get("https://www.cadandrender.com/adminPanel/API/students-counter.php").then((response)=>{
            setCounter(response.data.Counters);
        })
    },[]);

    return (
        <>
        <section className="cad-student-counter" ref={ref}>
            <div className="container">
                <div className="cad-student-counter-inner">
                    <div className="row cad-student-counterAln">
                    {counter.map((item, index) => (
                        <div className="cad-student-counterCols col-4" key={index}>
                            <div className="cad-student-counterColsInner">
                                <div className="cad-student-counterCards">
                                    <h5>{item.StudentCounter_Title}</h5>
                                    <h2>
                                        {inView ? <CountUp end={item.StudentCounter_Counts} duration={4} /> : '0'}+
                                    </h2>
                                </div>
                            </div>
                        </div>
                    ))}
                    </div>
                </div>
            </div>
        </section>
        </>
    );
};

export default StudentsCounter;